module.exports = __webpack_public_path__ + "static/media/Recurso 4.1e3331dc.svg";